import React from 'react';

// App Components
import RouterContainer from './RouterContainer';
import ReduxContainer from './ReduxContainer';
import AppContainer from './AppContainer';

// App Store
import store from './store/StoreContainer';

// App Service
import history from './services/History';

/**
 * Base container for the entire app.
 * @extends {Component}
 */
class RootContainer extends React.Component {
  /**
   * Attach all needed events to avoid drag and drop on uncontrolled areas
   */
  componentWillMount() {
    this.addDragDropListeners();
  }

  /**
   * It attaches a listener for the drag and drop events of the window object to avoid
   * dropping files outside the drag area
   */
  addDragDropListeners() {
    const [bodyElement] = document.getElementsByTagName('body');
    document.addEventListener('dragover', this.handleDragDrop, false);
    bodyElement.addEventListener('dragenter', this.handleDragDrop, false);
    bodyElement.addEventListener('dragleave', this.handleDragDrop, false);
    bodyElement.addEventListener('drop', this.handleDragDrop, false);
  }

  /**
   * This method handles all drag and drop events.
   * @param {Object} event The triggered drag/drop event.
   */
  handleDragDrop(event) {
    // All events need to be stopped to avoid dropping files outside the specific drop area.
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    return (
      <ReduxContainer store={store}>
        <AppContainer>
          <RouterContainer history={history} />
        </AppContainer>
      </ReduxContainer>
    );
  }
}

export default RootContainer;



// WEBPACK FOOTER //
// ./src/RootContainer.js